export default function fetchLogin (body) {
    return fetch( process.env.VUE_APP_API_ORIGIN + '/api/login', {
        method: 'POST',
        body,
    });
}
